var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left (1) 1",
    clipPath: "url(#clip0_3130_204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.4918 38.8701L34.4918 38.8971L36.1793 40L36.5981 39.3589L35.2575 38.4828V1.51722L36.5981 0.641057L36.1793 0L27.9395 5.38507L28.3583 6.02613L34.4918 2.01766V33.2683V38.8701Z",
    fill: "url(#paint0_linear_3130_204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.8626 36.1837L33.9729 38.87V33.2683V2.82861L28.4512 6.43729V28.5198H29.8626V36.1837ZM32.1336 20.6661L32.9886 20.1073V25.5212L32.1336 24.9623V20.6661Z",
    fill: "url(#paint1_linear_3130_204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3321 37.5921C13.6325 37.5921 13.9354 37.4975 14.1931 37.3017C14.8198 36.8256 14.9418 35.9315 14.4657 35.3049L11.4029 31.2737L11.5925 27.0049L8.59805 30.1901L8.53266 31.6621C8.51785 31.9949 8.62006 32.3223 8.82157 32.5875L12.1962 37.0291C12.4766 37.3981 12.9019 37.5921 13.3321 37.5921Z",
    fill: "url(#paint2_linear_3130_204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.61985 14.1178C6.36741 14.1483 6.12319 14.1642 5.89138 14.168C6.01709 15.4267 7.05657 16.4293 8.35564 16.4736C9.77144 16.5218 10.9584 15.4132 11.0066 13.9972C11.0548 12.5814 9.94607 11.3945 8.53027 11.3462C7.82747 11.3223 7.18137 11.5836 6.70273 12.0258C6.6571 12.0234 6.61198 12.0204 6.56569 12.0188C5.21276 11.9727 4.10341 12.301 4.08805 12.7521C4.07271 13.203 5.15713 13.6059 6.51007 13.652C7.7412 13.6939 8.76763 13.4255 8.95471 13.0372C8.96874 13.4787 7.93939 13.9585 6.61985 14.1178Z",
    fill: "url(#paint3_linear_3130_204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.27048 25.3756C8.25712 25.6013 8.25546 25.7964 8.2648 25.9666L5.26903 29.1532C5.08699 29.3468 4.96275 29.5875 4.91031 29.8481L3.69432 35.8904C3.539 36.6621 4.03856 37.4134 4.81022 37.5687C4.90507 37.5878 4.99971 37.597 5.0929 37.597C5.75757 37.597 6.3522 37.1295 6.48836 36.4528L7.62419 30.8091L11.6684 26.5072C11.7191 26.4533 11.7632 26.3956 11.8039 26.3364C12.0468 26.0424 12.2384 25.6379 12.3467 25.081C12.4076 24.5576 12.4476 24.08 12.4678 23.6288C12.5453 21.8968 12.3144 20.5758 11.6989 18.7513C11.1249 17.082 9.71403 16.5536 8.74075 16.7961C7.76768 17.0388 7.33971 18.3968 7.66682 19.5312C7.71282 19.7662 7.76426 20.0176 7.81736 20.2794L8.27472 19.0013C8.44461 18.5264 8.89753 18.2073 9.40187 18.2073C9.53914 18.2073 9.67486 18.2309 9.80501 18.2775C10.1062 18.3852 10.3472 18.6037 10.4839 18.8928C10.6205 19.1818 10.6366 19.5068 10.5288 19.8079L9.34766 23.1087C9.24356 23.3995 9.03437 23.636 8.7587 23.7747L8.33368 23.9886C8.33519 24.0444 8.33657 24.1002 8.33722 24.1559C8.34207 24.5702 8.32355 24.9797 8.27048 25.3756Z",
    fill: "url(#paint4_linear_3130_204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.08012 23.0126L10.2613 19.7117C10.431 19.2375 10.1841 18.7154 9.70984 18.5457C9.23566 18.3761 8.7135 18.6229 8.54384 19.0972L7.48561 22.0546L3.90465 23.8566C3.45463 24.083 3.2735 24.6313 3.49984 25.0812C3.66016 25.3997 3.98158 25.5835 4.31524 25.5835C4.45308 25.5835 4.59302 25.5521 4.7245 25.4859L8.63134 23.52C8.84054 23.4148 9.0012 23.2331 9.08012 23.0126Z",
    fill: "url(#paint5_linear_3130_204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.4629 28.9189H25.4866V33.0524L25.0364 32.7445L24.6285 33.0524L24.2478 32.7445L23.8127 33.0524L23.3866 32.7445L23.0935 33.0524V28.9189H19.1172V37.521H29.4629V28.9189Z",
    fill: "url(#paint6_linear_3130_204)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3130_204",
    x1: 32.2688,
    y1: 0,
    x2: 32.2688,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AF19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3130_204",
    x1: 31.212,
    y1: 2.82861,
    x2: 31.212,
    y2: 38.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AF19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3130_204",
    x1: 11.6437,
    y1: 27.0049,
    x2: 11.6437,
    y2: 37.5921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AF19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3130_204",
    x1: 7.54801,
    y1: 11.3447,
    x2: 7.54801,
    y2: 16.4751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AF19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3130_204",
    x1: 8.07412,
    y1: 16.7402,
    x2: 8.07412,
    y2: 37.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AF19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3130_204",
    x1: 6.85859,
    y1: 18.4922,
    x2: 6.85859,
    y2: 25.5835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AF19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3130_204",
    x1: 24.2901,
    y1: 28.9189,
    x2: 24.2901,
    y2: 37.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AF19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3130_204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.048a248a620ab35efdb3dd5e6e4729be.svg";
export { ForwardRef as ReactComponent };